import { createLogger } from '@/lib/logging';
import type { Logger } from 'loglevel';

export class LoggingService {
  private logger: Logger;

  constructor(context: string) {
    this.logger = createLogger(context);
  }

  info(message: string, data?: any) {
    if (data) {
      this.logger.info(message, data);
    } else {
      this.logger.info(message);
    }
  }

  error(message: string, error?: any) {
    if (error) {
      this.logger.error(message, error);
    } else {
      this.logger.error(message);
    }
  }

  debug(message: string, data?: any) {
    if (data) {
      this.logger.debug(message, data);
    } else {
      this.logger.debug(message);
    }
  }

  warn(message: string, data?: any) {
    if (data) {
      this.logger.warn(message, data);
    } else {
      this.logger.warn(message);
    }
  }

  trace(message: string, data?: any) {
    if (data) {
      this.logger.trace(message, data);
    } else {
      this.logger.trace(message);
    }
  }
} 